import { ListItem, ListItemIcon } from '@mui/material';
import { HowItWorksListCircle } from 'assets/icons/HowItWorksListCircle';
import { Color } from 'models';
import { ListItemsContainer, Text } from './BulletPointsList.styles';

interface BulletPointsListProps {
  color?: Color;
  content: string[];
  className?: string;
}

function BulletPointsList({ color = 'dark', className, content }: BulletPointsListProps) {
  return (
    <ListItemsContainer type={color} className={className}>
      {content.map((item: string, index: number) => (
        <ListItem key={item}>
          <ListItemIcon>
            <HowItWorksListCircle index={index + 1} />
          </ListItemIcon>
          <Text type={color} variant="h2">
            {item}
          </Text>
        </ListItem>
      ))}
    </ListItemsContainer>
  );
}

export default BulletPointsList;
